import React from 'react'
import Link from 'gatsby-link'
import Headroom from 'react-headroom'


export default function PostFilter(props) {
    return(
<Headroom className={`filter${(props.borders?" headroom-borders":"")}`}>
<nav className={`filter${(props.borders?" borders":"")}`}>
    <ul>
       {props.filterText}
        <li className={(props.currentCategory==null && props.currentCategory != "allInactive")?"active": ""}> <Link to="/blog/">Todos</Link></li>
        <li className={props.currentCategory=="libros"?"active": ""}> <Link to="/blog/libros/">Libros</Link></li>
        <li className={props.currentCategory=="tutoriales"?"active": ""}><Link to="/blog/tutoriales">Tutoriales</Link></li>
        {/*<li>Glosario</li>*/}
        
    </ul>

        </nav>
</Headroom>
)
}



// WEBPACK FOOTER //
// ./src/components/Linking/postFilter.js